import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type PingResponse = {
  message: string;
  timestamp: string;
};

export async function pingBackend(): Promise<PingResponse> {
  const ping = httpsCallable<void, PingResponse>(functions, 'ping');
  const result = await ping();
  return result.data;
}
